import { PaginationParams } from '../propTypes/commonTypes';

export const mapperPadeData = (value: PaginationParams) => ({page: value.page, pagesize: value.perPage});
